const deviceType = IsPC() ? 'pc' : 'mobile'
const host = process.env.NODE_ENV == 'development' ? 'https://api-mspl.m3guo.com/' : 'https://api-mspl.m3guo.com/';
const domain = process.env.NODE_ENV == 'development' ? 'http://192.168.217.171:8088/' : 'https://www.m3guo.com/activity/mspl/35cff/';

const getQueryVariable = function (variable) {
  var query = window.location.search.substring(1) || window.location.hash.substring(1);
  var vars = query.split("&");

  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return '';
}

function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
  }

const ajax_url_map = {
  mpl_list : host + 'api/Index/GetMpls',//获取mpl列表
  week_list : host + 'api/Index/GetMplWeeks',//获取mpl周列表
  race_list : host + 'api/Index/GetRaces',//获取赛程/季后赛分组显示
  live : host + 'api/Index/GetLives',
  news : host + 'api/Index/GetNews',
  ads : host + 'api/Index/Ads',
  video : host + 'api/Index/GetVideos',
  team : host + 'api/Index/GetTeams',
  anchor : host + 'api/Index/GetTalkers',
  corp : host + 'api/Index/GetFriends',
  score_race : host + 'api/Index/GetRaceScores',//赛程积分
  score_team : host + 'api/Index/GetTeamScores',//战队积分
  player_rank : host + 'api/Index/GetPlayers',//选手排行榜
  hero_rank : host + 'api/Index/GetHeros',//选手排行榜
}

export default {
    ajax_url_map,
    domain,
    getQueryVariable,
    deviceType,
  }


// WEBPACK FOOTER //
// ./src/assets/js/global.js